import 'waypoints/lib/noframework.waypoints'
import { preloadimages } from './utils';

export const lazy = (selector = '.lazy', offset = '100%') => {

   const lazyItems = document.querySelectorAll(selector)
   // console.log(selector,  offset);

   lazyItems.forEach(item => {

      new Waypoint({
         element: item,
         handler: function(direction){
            console.log(item);
            handleRatio(item)
            handleLazyItem(item)
            this.destroy()
         },
         offset: function(){
            if(typeof offset === 'function' ){
               return offset(this.element)
            } else {
               return window.innerHeight
            }
         }
      })
   })

   window.onresize = () => {
      const loadedItems = document.querySelectorAll('.lazy__loaded')
      loadedItems.forEach(item => {
         handleRatio(item)
         handleLazyItem(item)
      })
   }
}

const handleRatio = (item) => {

   const parentItem = item.parentElement 
   const hasLazyContainerWithRatio = parentItem.classList.contains('lazy-container') && parentItem.getAttribute('data-ratio') && parentItem.getAttribute('data-ratio-mobile')

   if(hasLazyContainerWithRatio){
      console.log('lazy: ', parentItem);
      let ratio;
      if(window.innerWidth <= 768){
         ratio = parentItem.getAttribute('data-ratio-mobile')
      } else {
         ratio = parentItem.getAttribute('data-ratio')
      }
      parentItem.style.paddingBottom = ratio
   }
}

const handleLazyItem = (item) => {
   
   const animationClassesArray = item.getAttribute('data-animation')
   const img_src_desktop = item.getAttribute('data-src') || item.getAttribute('data-gmsrc')
   const img_src_mobile = item.getAttribute('data-src-mobile')
   const img_src_big = item.getAttribute('data-src-big')
   let img_src
   const img_bg_desktop = item.getAttribute('data-bg')
   const img_bg_mobile = item.getAttribute('data-bg-mobile')
   let img_bg

   const parentItem = item.parentElement 
   
   if(window.innerWidth <= 768){
      img_src = img_src_mobile ? img_src_mobile : img_src_desktop
      img_bg = img_bg_mobile ? img_bg_mobile : img_bg_desktop
   } else if (window.innerWidth <= 1870) {
      img_src = img_src_desktop
      img_bg = img_bg_desktop
   } else {
      img_src = img_src_big ? img_src_big : img_src_desktop
      img_bg = img_bg_desktop
   }

   if(img_src){
      preloadimages([img_src]).done(images => {
         images.forEach( image => {
            item.setAttribute('src', img_src)
            item.classList.add('lazy__loaded')
            if(isLazyContainer(parentItem)){
               parentItem.classList.add('lazy-container--loaded')
            } else if(isLazyContainer(parentItem.parentElement)) {
               parentItem.parentElement.classList.add('lazy-container--loaded')
            }
         })
      })
   }

   if(img_bg){
      preloadimages([img_bg]).done(images => {
         images.forEach( image => {
            item.style.backgroundImage = `url(${img_bg})`
            setTimeout(() => {
               item.classList.add('lazy--loaded')
            }, 300);
         })
      })
   }

   if(animationClassesArray){
      animationClassesArray.split(' ').forEach(animationClass => {
         item.classList.add(animationClass)   
      })
   }
}

//*******************************************************
// helpers
//*******************************************************

   const isLazyContainer = (item) => item.classList.contains('lazy-container')
